import React, {ReactNode, useCallback} from "react";
import {translationEn} from "./translation.en";
import {RawTranslationFn, TranslationProvider} from "../../translation";

import {translationDe} from "./translation.de";
import {translationSe} from "./translation.se";
import {pathToValue} from "@me8eon/record_utils";
import {useThrowError} from "@me8eon/throw_error";
import {Language, useLanguage} from "@me8eon/language";
import { useTranslation } from "react-i18next";

export function makeTranslationFn(translation: Record<string, any>): RawTranslationFn {
    return (key: string) => {
        return pathToValue(translation, key);
    };
}

type LanguageLookup = Record<Language, Record<string, any>>;
type LanguageLookupTranslationProvider = { children: ReactNode, languageLookup?: LanguageLookup }

export const defaultLanguageLookup: LanguageLookup = {
    en: translationEn,
    de: translationDe,
    se: translationSe
};

export function SimpleTranslationProvider({children, languageLookup = defaultLanguageLookup}: LanguageLookupTranslationProvider) {
    let [language] = useLanguage();
    const { i18n } = useTranslation();
    const throwError = useThrowError();
    const translationFn = useCallback<RawTranslationFn>(
        key => {
            if (!languageLookup[language]) {
                language = "en";
                i18n.changeLanguage(language);
            }
            const lang = languageLookup[language];
            if (!lang) return throwError('s/w', `Language ${language} not found in languageLookup. Legal values are ${Object.keys(languageLookup)}`);
            return makeTranslationFn(lang)(key);
        }, [language, languageLookup]);
    return <TranslationProvider translationFn={translationFn}>{children}</TranslationProvider>;
}